import { PencilSquareIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import usePageIndex from "../../hooks/usePageIndex";
import { ICity } from "../../interfaces/endpoints/ILocations";
import { OperatorsSelectList } from "../../interfaces/endpoints/IOperators";
import { IServiceFee } from "../../interfaces/endpoints/IServiceFee";
import { getAllCities } from "../../services/Locations.service";
import { getAllSelectOperators } from "../../services/Operators.service";
import {
  deleteServiceFee,
  getAllServiceFees
} from "../../services/ServiceFee.service";
import IconBtn from "../ui/IconBtn";
import Table, { Row } from "../ui/table";
import DeleteServiceFeeModal from "./DeleteServiceFeeModal";

const columns: (string | number)[] = [
  "Nisja",
  "Mbërritja",
  "Operatori",
  "Përqindja",
  "Veprimet"
];

const ServiceFeesTable = () => {
  const [data, setData] = useState<IServiceFee[]>([]);
  const [loading, setLoading] = useState(true);
  const [cityMap, setCityMap] = useState<Record<number, string>>({});
  const [operatorMap, setOperatorMap] = useState<Record<number, string>>({});
  const { pageIndex }: any = usePageIndex();

  useEffect(() => {
    setLoading(true);
    Promise.all([
      getAllServiceFees(),
      getAllCities({ pageSize: 3000 }),
      getAllSelectOperators({ pageIndex: 0, pageSize: 2000 })
    ])
      .then(([feesRes, citiesRes, operatorsRes]) => {
        setData(feesRes.data || []);

        const cities: ICity[] = citiesRes.data?.result || [];
        const cMap: Record<number, string> = {};
        cities.forEach((c) => {
          cMap[c.id] = c.locationName;
        });
        setCityMap(cMap);

        const operators: OperatorsSelectList[] = operatorsRes.data?.result || [];
        const oMap: Record<number, string> = {};
        operators.forEach((o) => {
          oMap[o.id] = o.operatorName || "";
        });
        setOperatorMap(oMap);
      })
      .catch(() => {
        toast.error("Ndodhi një gabim gjatë marrjes së të dhënave.");
      })
      .finally(() => setLoading(false));
  }, []);

  const handleDelete = (id: number) => {
    deleteServiceFee(id)
      .then(() => {
        toast.success("Konfigurimi është fshirë me sukses.", {
          position: "top-right"
        });
        setData((prev) => prev.filter((el) => el.id !== id));
      })
      .catch(() => toast.error("Ndodhi një gabim gjatë fshirjes."));
  };

  return (
    <div className="flex flex-col" style={{ height: "calc(100vh - 11rem)" }}>
      <Table
        titles={columns}
        loading={loading}
        className="overflow-x-auto"
        style="hover"
      >
        {data?.length ? (
          data.map((row, i: number) => {
            return (
              <Row
                key={i}
                departureCityId={cityMap[row.departureCityId] || row.departureCityId}
                arrivalCityId={cityMap[row.arrivalCityId] || row.arrivalCityId}
                operatorId={
                  row.operatorId ? (operatorMap[row.operatorId] || row.operatorId) : "Të gjithë operatorët"
                }
                percentage={`${(row.percentage * 100).toFixed(2)}%`}
                actions={
                  <span className="flex items-center">
                    <Link
                      to={`/service-fees/edit/${row.id}`}
                      state={{
                        crumbs: ["Service Fees", "Modifiko konfigurimin"],
                        page: pageIndex,
                        feeData: row
                      }}
                    >
                      <IconBtn className="w-6 h-6">
                        <PencilSquareIcon className="w-4 h-4" />
                      </IconBtn>
                    </Link>
                    <DeleteServiceFeeModal
                      handleDelete={() => handleDelete(row.id)}
                    />
                  </span>
                }
              />
            );
          })
        ) : (
          <></>
        )}
      </Table>
    </div>
  );
};

export default ServiceFeesTable;
